module.exports = __webpack_public_path__ + "img/nomenclatures.b5d94465.png";